import { Routes } from "@angular/router";

const scope: string = "feature/area-management-routes";

export const AREA_MANAGEMENT_ROUTES: Routes = [
  { path: "" },
  { path: "modules" },
  {
    path: "plans",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Flächendefinition",
              token: "breadcrumb-label-area-definition",
              scope
            }
          }
        }
      }
    }
  },
  {
    path: "area-assign",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Flächen Vermieten",
              token: "breadcrumb-label-rent-areas",
              scope
            }
          }
        }
      }
    }
  },
  {
    path: "withdraw-assign",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Flächen zurücknehmen",
              token: "breadcrumb-label-withdraw-areas",
              scope
            }
          }
        }
      }
    }
  },
  {
    path: "assignments-overview",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Übersicht Flächenbelegung",
              token: "breadcrumb-label-assignments-overview",
              scope
            }
          }
        }
      }
    }
  }
];
